import { render, staticRenderFns } from "./OximetryMeasurements.vue?vue&type=template&id=4e251e4f&scoped=true"
import script from "./OximetryMeasurements.vue?vue&type=script&lang=js"
export * from "./OximetryMeasurements.vue?vue&type=script&lang=js"
import style0 from "./OximetryMeasurements.vue?vue&type=style&index=0&id=4e251e4f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e251e4f",
  null
  
)

export default component.exports